import { Navigate, Outlet } from "react-router-dom";
import { Role } from "../constants/enums";
import { ROUTES } from "../constants/routes";
import { useAppContext } from "../contexts/AppContext";

/**
 * Route guard that only allows admin (and optionally moderator) users.
 * Non-admin users are redirected to the dashboard.
 * While loading, shows nothing (ProtectedRoute already handles auth).
 */
const AdminRoute = ({ allowModerator = false }: { allowModerator?: boolean }) => {
  const { user, loading } = useAppContext();

  if (loading) return null;

  const allowedRoles: string[] = [Role.ADMIN];
  if (allowModerator) allowedRoles.push(Role.MODERATOR);

  if (!user || !allowedRoles.includes(user.role)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
